/**
 * @generated SignedSource<<d9adda12de91fb33a09749e635a40a5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeepArState = "COMPLETED" | "ERROR" | "PROCESSING" | "WAITING";
export type deepARTaskPollingQuery$variables = {
  id: string;
};
export type deepARTaskPollingQuery$data = {
  readonly deepArTask: {
    readonly settings: {
      readonly environment: string;
      readonly position: {
        readonly x: number;
        readonly y: number;
        readonly z: number;
      };
      readonly rotation: {
        readonly x: number;
        readonly y: number;
        readonly z: number;
      };
      readonly scale: number;
    };
    readonly state: DeepArState;
  } | null;
};
export type deepARTaskPollingQuery = {
  response: deepARTaskPollingQuery$data;
  variables: deepARTaskPollingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "x",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "y",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "z",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "DeepArSetting",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Coordinates",
      "kind": "LinkedField",
      "name": "position",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Coordinates",
      "kind": "LinkedField",
      "name": "rotation",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "environment",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deepARTaskPollingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeepArTask",
        "kind": "LinkedField",
        "name": "deepArTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deepARTaskPollingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeepArTask",
        "kind": "LinkedField",
        "name": "deepArTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "647db483e44c81b59a6b174bbdac4981",
    "id": null,
    "metadata": {},
    "name": "deepARTaskPollingQuery",
    "operationKind": "query",
    "text": "query deepARTaskPollingQuery(\n  $id: ID!\n) {\n  deepArTask(id: $id) {\n    state\n    settings {\n      position {\n        x\n        y\n        z\n      }\n      rotation {\n        x\n        y\n        z\n      }\n      scale\n      environment\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6fdb1223712207ab551e2f9e0abf325";

export default node;
